export enum SipStatus {
  OPEN = 'open',
  ERROR = 'error',
  CLOSE = 'close',
  SUCCESS = 'success',
  FAILED = 'failed',
}
